export enum SaleStatType {
  ROOMS = 'ROOMS',
  AREA = 'AREA',
  COUNT = 'COUNT',
  FLOOR = 'FLOOR',
  APARTMENT = 'APARTMENT'
}
